export const entryFee = {
  BTC: 100,
  ETH: 10,
};
